export function decodeHTML(input: string): string | null {
  const parsedURL = new DOMParser().parseFromString(input, 'text/html');
  return parsedURL.documentElement.textContent;
}
